export default __webpack_public_path__ + "static/media/home-gray.425b50ef.svg";